var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaceholderAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "124px",
    height: "124px",
    viewBox: "0 0 124 124",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "94.5123255%",
    y1: "83.7378561%",
    x2: "19.6413923%",
    y2: "4.632213%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-2",
    cx: 62,
    cy: 62,
    r: 62
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "35.2282072%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD0CE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5ACA9",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HH---Your-company",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HH---Your-company-3",
    transform: "translate(-127.000000, -476.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy",
    transform: "translate(127.000000, 476.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "url(#linearGradient-1)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.283447, 9.941905)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45,74.0580953 C-7.71649932,74.0580953 0.458068438,97.7313816 0.458068438,108.162907 C0.458068438,118.594432 23.5538848,126.058095 45,126.058095 C66.4461152,126.058095 89.5419316,123.731382 89.5419316,108.162907 C89.5419316,92.5944323 97.7164993,74.0580953 45,74.0580953 Z",
    id: "Path-27-Copy-4",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0940201,65.9293498 C44.0626801,65.8754035 45.03134,65.8484303 46,65.8484303 C46.96866,65.8484303 47.9373199,65.8754035 48.9059799,65.9293498 L48.9059782,65.9293799 C65.6713464,66.8630712 80.019269,54.0289614 80.9529603,37.2635933 C80.984314,36.7006059 81,36.1368553 81,35.5729955 C81,35.5729955 81,35.5729955 81,35.5729955 C81,15.9265726 65.3299662,0 46,0 C26.6700338,0 11,15.9265726 11,35.5729955 C11,35.5729955 11,35.5729955 11,35.5729955 C11,52.3643429 24.6120766,65.9764195 41.403424,65.9764195 C41.9672838,65.9764195 42.5310344,65.9607336 43.0940218,65.9293799 Z",
    id: "Oval-Copy-18",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    fill: "url(#linearGradient-4)",
    x: 33,
    y: 56,
    width: 24,
    height: 35,
    rx: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,80 C59.8071187,80 71,57.4421182 71,41.9859209 C71,26.5297236 59.8071187,14 46,14 C32.1928813,14 21,26.5297236 21,41.9859209 C21,57.4421182 32.1928813,80 46,80 Z",
    id: "Oval-Copy-19",
    fill: "#FFD0CE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(19.383220, 11.058095)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.8333333,3 C33.7025081,11.3615371 41.8691748,16.6948704 50.3333333,19 C50.3333333,16.399341 49.1666667,10.0660076 46.8333333,0 L7.33333333,0 C-1.27009514e-13,14 -1.83333333,23.8333333 1.83333333,29.5 C11.5000609,27.1948704 19.5000609,18.3615371 25.8333333,3 Z",
    id: "Path-28-Copy-2",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1811594,0 C27.1811594,10.3333333 26.0144928,17.3333333 22.6811594,21 C21.1811594,13 20.6811594,11.5 18.6811594,8.5 C17.3478261,6.5 19.8478261,3.66666667 26.1811594,0 Z",
    id: "Path",
    fill: "#575756"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderAvatar);
export default __webpack_public_path__ + "static/media/placeholderAvatar.10d37b33ca4e3b04365d15aeedb9cf50.svg";
export { ForwardRef as ReactComponent };